import React from 'react'
import {clsx} from 'clsx'
import styles from './TipsContentList.module.css'

interface TipsConentListType {
  value: React.ReactNode
  name: string
}

export default function TipsContentList({data}: {data: TipsConentListType[]}) {
  return (
    <div className={styles.gridContainer}>
      {data.map((d, index) => {
        const isEnd = index + 1 === data.length
        return (
          <React.Fragment key={d.name}>
            <div className={clsx(styles.nameCell, index !== 0 && styles.nameCellNotFirst)}>
              <span className={styles.nameText}>{d.name}</span>
            </div>
            <div className={clsx(styles.valueCell, index === 0 && styles.valueCellFirst, isEnd && styles.valueCellEnd)}>
              <span className={styles.valueText}>{d.value}</span>
            </div>
          </React.Fragment>
        )
      })}
    </div>
  )
}
